<template>
  <!-- Tabs of the current section (design: ArbeitSubtabs / PersonalSubtabs / BildungSubtabs) -->
  <div v-if="tabs.length" class="ts-subtabs-strip">
    <nav class="container ts-subtabs d-flex" :aria-label="label">
      <router-link
        v-for="tab in tabs"
        :key="tab.route"
        class="ts-subtab-link text-nowrap"
        :class="{ 'active fw-semibold': isActive(tab) }"
        :aria-current="isActive(tab) ? 'page' : null"
        :to="{ name: tab.route, query: { lang } }"
        :event="[]"
        @click.native="select($event, tab)"
      >
        <i class="bi" :class="tab.icon" aria-hidden="true"></i>
        {{ tab.label }}
      </router-link>
    </nav>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { SectionTab, sectionTabs } from '@/config/sectionTabs';

@Component
export default class TsSectionTabs extends Vue {
  get section(): string {
    return this.$route.meta?.section || '';
  }

  get tabs(): SectionTab[] {
    return sectionTabs(this.section);
  }

  // The section's main navigation item names the tab bar for screen readers
  get label() {
    return this.tabs[0]?.label || '';
  }

  get lang() {
    return AppModule.language;
  }

  isActive(tab: SectionTab) {
    const name = this.$route.name || '';
    return tab.route === name || Boolean(tab.activeOn?.includes(name));
  }

  // Navigate first, then reset the section state: a reset while the old page is still shown
  // would let the section parent (JobsView, WorkersView) send it back to its search page
  select(event: MouseEvent, tab: SectionTab) {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
    event.preventDefault();
    const done = () => tab.onSelect?.();
    this.$router.push({ name: tab.route, query: { lang: this.lang } }).then(done).catch(done);
  }
}
</script>
